var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form__row row s-2-bmargin"},[_vm._t("inputs",null,{"callback":_vm.inputOnChange}),_vm._v(" "),_vm._t("outputs",null,{"selected":_vm.selected})],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-978bc954","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/vue/transfer-group.vue
// module id = hBzn
// module chunks = 0